import React from 'react';

interface HeaderProps {
  activeTab: 'new' | 'history';
  onTabChange: (tab: 'new' | 'history') => void;
}

const Header: React.FC<HeaderProps> = ({ activeTab, onTabChange }) => {
  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex justify-between items-center">
        <div className="flex space-x-8">
          <button
            onClick={() => onTabChange('new')}
            className={`font-medium pb-2 ${
              activeTab === 'new'
                ? 'text-green-600 border-b-2 border-green-600'
                : 'text-gray-600 hover:text-blue-600'
            }`}
          >
            New
          </button>
          <button
            onClick={() => onTabChange('history')}
            className={`font-medium pb-2 ${
              activeTab === 'history'
                ? 'text-green-600 border-b-2 border-green-600'
                : 'text-gray-600 hover:text-blue-600'
            }`}
          >
            History
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;